import { render, staticRenderFns } from "./TourSmall.vue?vue&type=template&id=462b874f"
import script from "./TourSmall.vue?vue&type=script&lang=js"
export * from "./TourSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462b874f')) {
      api.createRecord('462b874f', component.options)
    } else {
      api.reload('462b874f', component.options)
    }
    module.hot.accept("./TourSmall.vue?vue&type=template&id=462b874f", function () {
      api.rerender('462b874f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourSmall.vue"
export default component.exports